module.exports = __webpack_public_path__ + "img/CENTRIF.78caa82e.jpg";